export { default } from './HighlightText';
